export default {"src":"/_next/static/media/logo.8664649e.svg","height":82,"width":365,"blurWidth":0,"blurHeight":0};